import SuburbPestControlPage from "../components/SuburbPestControlPage";
import { IPSWICH_SUBURBS } from "../data/ipswichSuburbs";

export default function PestControlEastIpswichPage() {
  return <SuburbPestControlPage suburb={IPSWICH_SUBURBS["east-ipswich"]} />;
}
